import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FlxCommonsModule } from "@questrade/flx-commons";
import { ExtMagento_1Page } from './ext-magento-1';
import { FlxDoclistComponentModule } from '../../../../components/flx-doclist/flx-doclist.module';
import { DevWrapperComponentModule } from '../../../../components/dev-wrapper/dev-wrapper.module';

@NgModule({
    declarations: [
        ExtMagento_1Page,
    ],
    imports: [
        DevWrapperComponentModule,
        FlxCommonsModule,
        FlxDoclistComponentModule,
        IonicPageModule.forChild(ExtMagento_1Page),
    ],
    exports: [
        ExtMagento_1Page
    ]
})
export class ExtMagento_1PageModule { }



// WEBPACK FOOTER //
// ./src/pages/extensions/ext-platforms/ext-magento-1/ext-magento-1.module.ts